import { render, staticRenderFns } from "./ContentHistory.vue?vue&type=template&id=e2f622d4&scoped=true&"
import script from "./ContentHistory.vue?vue&type=script&lang=js&"
export * from "./ContentHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContentHistory.vue?vue&type=style&index=0&id=e2f622d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f622d4",
  null
  
)

export default component.exports